import Vue from 'vue';
import VueI18n from 'vue-i18n';
import VueFuse from 'vue-fuse';
import { GIT_HASH } from './utils/version';
import messages from './lang';
import App from './App.vue';
import router from './router';
import store from './store';

// console.log('version: ', GIT_HASH);

Vue.config.productionTip = false;

Vue.use(VueI18n);
// Create VueI18n instance with options
const i18n = new VueI18n({
  locale: 'en', // set locale
  messages, // set locale messages
});

Vue.use(VueFuse);
window.EventBus = new Vue();

Vue.directive('focus', {
  inserted: function (el) {
    // Focus the element
    el.focus()
  }
})

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app');
